import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ProjectMaterialsSlider.css";

const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow-materials custom-prev-arrow" onClick={onClick}>
      <img src="/images/leftarrow.svg" alt="Previous" />
    </div>
  );
};

// Custom Next Arrow
const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow-materials custom-next-arrow" onClick={onClick}>
      <img src="/images/rightarrow.svg" alt="Next" />
    </div>
  );
};
function ProjectMaterialsSlider({ videos }) {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [posterUrls, setPosterUrls] = useState({}); // Store poster URLs for each video
  const mediaQuery = window.matchMedia("(max-width: 600px)");

  // Check screen size
  useEffect(() => {
    const handleResize = () => setIsSmallScreen(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleResize);
    handleResize(); // Initial check
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, [mediaQuery]);

  // Function to extract the first frame as a poster for a video
  const extractPoster = (videoUrl, index) => {
    const video = document.createElement("video");
    video.crossOrigin = "anonymous"; // Handle CORS if needed
    video.src = videoUrl;
    video.preload = "auto"; // Load only metadata, not the full video

    // Log video loading progress
    video.addEventListener("loadstart", () => {});

    video.addEventListener("loadeddata", () => {
      video.currentTime = 0.01; // Seek to the first frame

      video.addEventListener("seeked", () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Convert to a compressed data URL
        const posterUrl = canvas.toDataURL("image/jpeg", 0.7); // 70% quality to reduce size

        // Update the poster URLs state
        setPosterUrls((prev) => ({ ...prev, [index]: posterUrl }));
      });
    });

    video.load();
  };

  // Extract posters for all videos when the component mounts
  useEffect(() => {
    videos.forEach((video, index) => {
      const videoUrl = `${
        process.env.REACT_APP_BACKEND_URL_VIDEOS
      }${encodeURIComponent(video.videoUrl)}`;
      extractPoster(videoUrl, index);
    });
  }, [videos]);

  // Pause all videos when the user scrolls
  useEffect(() => {
    const handleScroll = () => {
      const allVideos = document.querySelectorAll("video");
      allVideos.forEach((video) => video.pause());
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Handle video play event
  const handlePlay = (event) => {
    const currentVideo = event.target;

    // Pause all other videos
    const allVideos = document.querySelectorAll("video");
    allVideos.forEach((video) => {
      if (video !== currentVideo) video.pause();
    });

    // Unmute the current video when it starts playing
    currentVideo.muted = false;
  };

  // Slider settings
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow: <CustomPrevArrow />, // Custom previous arrow
    nextArrow: <CustomNextArrow />, // Custom next arrow
  };

  return (
    <div className="ProjectMaterialsSlider-container">
      <Slider {...settings}>
        {videos.map((video, index) => (
          <div key={index} className="video-slide">
            <video
              muted={isSmallScreen}
              src={`${
                process.env.REACT_APP_BACKEND_URL_VIDEOS
              }${encodeURIComponent(video.videoUrl)}`}
              playsInline
              controls
              preload="auto"
              loop
              onPlay={handlePlay}
              poster={posterUrls[index]} // Set the poster dynamically
              onLoadedMetadata={(e) => (e.target.currentTime = 0.001)}
            >
              <source
                src={`${
                  process.env.REACT_APP_BACKEND_URL_VIDEOS
                }${encodeURIComponent(video.videoUrl)}`}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ProjectMaterialsSlider;
